import { render } from "./video-show.vue?vue&type=template&id=31588c73&scoped=true"
import script from "./video-show.vue?vue&type=script&lang=js"
export * from "./video-show.vue?vue&type=script&lang=js"

import "./video-show.vue?vue&type=style&index=0&id=31588c73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31588c73"]])

export default __exports__